import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';
import { usePermission } from '../../hooks/usePermission';

export const ProtectedRoute = ({ children, permission, requiredRole, mode = 'OR' }) => {
  const { isAuthenticated, isInitializing, firstLogin } = useAuth();
  const { can } = usePermission();

  if (isInitializing) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (firstLogin === true && window.location.pathname !== '/firstLogin') {
    return <Navigate to="/firstLogin" replace />;
  }

  const isAllowed = can({
    role: requiredRole,
    permission,
    mode,
  });

  if (!isAllowed) {
    return <Navigate to="/404" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  requiredRole: PropTypes.string,
  mode: PropTypes.oneOf(['AND', 'OR']),
};
